export default "__VITE_ASSET__0a68e413__"